export const InfoPage: React.FC = () => {
  const info = window.navigator?.userAgent;

  return <span>{info}</span>;
};
